<template>
  <div class="export-pdf-container greeting-container">
    <div class="box-header">
      <p class="title">GREETINGS!</p>
    </div>
    <div class="content greetings one-page">
      <p class="paragraph">
        The Regional Rating System - <span class="upm-u">UNIVERSITY </span>
        <span class="upm-p">PERFORMANCE </span>
        <span class="upm-m">METRICS</span> - <span class="upm-u">U</span
        ><span class="upm-p">P</span><span class="upm-m">M</span> has been
        developed to assess the responsiveness of universities in the Fourth
        Industrial Revolution era through the five core indicators:
        <span class="paragraph-italic"
          >Entrepreneurial Spirit, Innovative Approaches, Digital
          Transformation, Student Mobility, and Ethical Values.</span
        >
      </p>
      <p class="paragraph">
        <span class="upm-u">U</span><span class="upm-u">P</span
        ><span class="upm-m">M</span> includes a set of 52 indicators across 8
        categories following two distinctive orientations: research and
        application. Evaluation results are presented in the form of an overall
        score for the whole institution and a score for each category and each
        indicator, corresponding to a number of Stars ranging from 1 – 5 and 5
        Stars ELITE. Institutions awarded with higher star numbers indicate
        exemplary reputation, the highest of which are at a competitive level of
        the Top 500 world universities (for 5-stars ELITE research-intensive
        HEIs), Top 1000 world universities (for 5-stars research-intensive HEIs)
        and Top 1000 Asian universities (for 5-stars teaching focus HEIs).
      </p>
      <p class="paragraph">
        This rating system could bring significant benefits to different
        stakeholders. Higher-education institutions can use it as a benchmark
        tool for strategic development, as well as evidence-based branding for
        attracting students and potential partners.
      </p>
      <p class="paragraph">
        Benchmarking results can be used as useful indicators for students to
        select study destinations and for employers to recruit qualified human
        resources. They can also be a reliable source of reference for national
        governments to make future policies or decisions on education.
      </p>
      <p class="paragraph">
        <span class="upm-u">U</span><span class="upm-u">P</span
        ><span class="upm-m">M</span> is extremely pleased to inform you the
        benchmarking results of your institution. This assessment report
        presents the detailed rating results and the data that has been used as
        the basis for the rating score. Hopefully, this would provide you with
        useful information for your institution’s self-benchmarking and
        strategic governance. In addition, you can use it for your media
        communication.
      </p>
      <p class="paragraph">
        Thank you for taking part in <span class="upm-u">U</span
        ><span class="upm-p">P</span><span class="upm-m">M</span>. If you need
        any further information about the results, please feel free to contact
        us at <span class="upm-link">upm@vnu.edu.vn</span>.
      </p>
      <div class="box-person">
        <img class="certificate-logo" :src="'img/imgPdf/logo-upm.png'" alt="" />
      </div>
    </div>
    <div class="box-footer box-header">
      <p class="title">Innovate to Transcend</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Greetings",
  props: {
    universityInfo: {}
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/pdf.scss";
</style>
